import {MsalProvider} from '@azure/msal-react';
import {AuthGate} from 'shared';

import {LoadingScreen} from '@/components/LoadingScreen/LoadingScreen';
import {mainRequest, msal} from '@/lib/azure';

import {MediaTokenSetup} from './MediaTokenSetup';

type ProviderProps = {
  children: React.ReactNode;
};

export function AuthProvider(props: ProviderProps): React.JSX.Element {
  return (
    <MsalProvider instance={msal}>
      <AuthGate mainRequest={mainRequest} fallback={<LoadingScreen />}>
        <MediaTokenSetup />
        {props.children}
      </AuthGate>
    </MsalProvider>
  );
}

AuthProvider.displayName = 'AuthProvider';
